import { render, staticRenderFns } from "./needsDetection.vue?vue&type=template&id=b59e128c&scoped=true"
import script from "./needsDetection.vue?vue&type=script&lang=js"
export * from "./needsDetection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b59e128c",
  null
  
)

export default component.exports